'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toString = toString;
//  weak
var UNINITIALIZED = exports.UNINITIALIZED = -2;
var INITIALIZED = exports.INITIALIZED = -1;
var HIDDEN = exports.HIDDEN = 1;
var APPEARING = exports.APPEARING = 2;
var SHOWN = exports.SHOWN = 3;
var SWAPPING = exports.SWAPPING = 4;
var DISAPPEARING = exports.DISAPPEARING = 5;

function toString(status) {
    switch (status) {
        case UNINITIALIZED:
            return 'UNINITIALIZED';
        case INITIALIZED:
            return 'INITIALIZED';
        case HIDDEN:
            return 'HIDDEN';
        case APPEARING:
            return 'APPEARING';
        case SHOWN:
            return 'SHOWN';
        case SWAPPING:
            return 'SWAPPING';
        case DISAPPEARING:
            return 'DISAPPEARING';
        default:
            return 'UNKNOWN';
    }
}
//# sourceMappingURL=TransitionStatus.js.map